
export default {
  props: {
    /**
     * Объект с микроразметкой schema.org
     */
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  head() {
    return {
      script: [
        {
          json: this.data,
          type: 'application/ld+json',
        },
      ],
    }
  },
  render(h) {
    return h()
  },
}
